import React, { FC } from 'react'
import { Modal } from 'flowbite-react'
import { AnimatePresence, motion } from 'framer-motion'
import { HiCheck } from 'react-icons/hi';

const SuccessModal: FC<{ show: boolean, setShow: (value: boolean) => void, description: string, children?: React.ReactNode }> = ({ show, setShow, description, children }) => {
  return (  
    <Modal
      show={show}
      onClose={() => setShow(false)}
    >
      <AnimatePresence>
        <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50"
            >
                <div className="bg-white rounded-xl shadow-xl p-6 max-w-sm w-full">
                    <div className="flex items-center justify-center w-12 h-12 rounded-full bg-green-100 mx-auto mb-4">
                        <HiCheck className="w-6 h-6 text-green-600" />
                    </div>
                    <h3 className="text-xl font-semibold text-center text-gray-900 mb-2">Success!</h3>
                    <p className="text-center text-gray-600 mb-6">{description}</p>
                    {children && children}
                    <button
                        onClick={() => setShow(false)}
                        className="w-full px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                    >
                        Close
                    </button>
                </div>
            </motion.div>
      </AnimatePresence>
    </Modal>
  )
}

export default SuccessModal